import styled, { css, CSSObject } from "styled-components";
import CameraIcon from "ui/common/icons/CameraIcon";
import { ImageUploadPlaceholderProps } from "./ImageUploadPlaceholder";

export const IMAGE_UPLOAD_PLACEHOLDER_STYLES: Record<ImageUploadPlaceholderProps["size"], CSSObject> = {
    xs: {
        fontSize: "1.5rem",
    },
    sm: {
        fontSize: "2rem",
    },
    md: {
        fontSize: "2.5rem",
    },
    lg: {
        fontSize: "3rem",
    },
    xl: {
        fontSize: "3.5rem",
    },
};

export const ImageUploadPlaceholderRoot = styled(CameraIcon)<ImageUploadPlaceholderProps>(
    ({ theme: { palette }, size }) => css`
        color: ${palette.gray[300]};
        ${IMAGE_UPLOAD_PLACEHOLDER_STYLES[size]}
    `,
);
